var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.15 18.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-trash-2",
    "data-name": "Icon feather-trash-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.4,5H.75a.75.75,0,0,1,0-1.5H16.4a.75.75,0,0,1,0,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.92,18.89H4.23A2.5,2.5,0,0,1,1.74,16.4V4.23a.75.75,0,0,1,1.5,0V16.4a1,1,0,0,0,1,1h8.69a1,1,0,0,0,1-1V4.23a.75.75,0,0,1,1.5,0V16.4A2.5,2.5,0,0,1,12.92,18.89ZM12.05,5a.76.76,0,0,1-.75-.75V2.49a1,1,0,0,0-1-1H6.84a1,1,0,0,0-1,1V4.23a.75.75,0,0,1-1.5,0V2.49A2.49,2.49,0,0,1,6.84,0h3.47A2.49,2.49,0,0,1,12.8,2.49V4.23A.75.75,0,0,1,12.05,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.84,14.54a.74.74,0,0,1-.75-.75V8.58a.75.75,0,0,1,1.5,0v5.21A.75.75,0,0,1,6.84,14.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.31,14.54a.75.75,0,0,1-.75-.75V8.58a.75.75,0,0,1,1.5,0v5.21A.74.74,0,0,1,10.31,14.54Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.0412bbe39cfe1376da23155d7681a201.svg";
export { ForwardRef as ReactComponent };